import {useMemo} from 'react'
import {Card, Flex, Loading} from '@binance/uikit'
import {SETTING} from 'constants'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useOpenAccount from 'hooks/useOpenAccount'
import OrderForm from './OrderForm'
import OpenAccountView from './OpenAccount'

export default function RenderOrderForm ({i18n}) {
  const {openAccountAvailable} = SETTING
  const isLogin = useUserLoginStatus()
  const {isOpenAccount} = useOpenAccount(i18n, '')
  const shouldShowOpenAccountForm = isLogin && isOpenAccount === false
  const shouldShowOrderForm = isLogin === false || isOpenAccount

  return useMemo(
    () => (
      <>
        {isLogin === undefined && isOpenAccount === undefined && (
          <Card gridArea="orderform">
            <Flex alignItems="center" justifyContent="center" height="100%">
              <Loading width="50px" />
            </Flex>
          </Card>
        )}
        {openAccountAvailable ? (
          shouldShowOpenAccountForm ? (
            <OpenAccountView i18n={i18n} />
          ) : (
            shouldShowOrderForm && <OrderForm i18n={i18n} />
          )
        ) : (
          <OrderForm i18n={i18n} />
        )}
      </>
    ),
    [
      i18n,
      isLogin,
      isOpenAccount,
      openAccountAvailable,
      shouldShowOpenAccountForm,
      shouldShowOrderForm
    ]
  )
}
